import type { ReactNode } from "react";
import { useFintechUiStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFintechUiComponents } from "@b2bportal/core-types";

import defaultStyles from "./FintechMarketplaceProductBreadcrumbItem.module.scss";

export interface FintechMarketplaceProductBreadcrumbItemProps {
  active: boolean;
  children: ReactNode;
}

export const FintechMarketplaceProductBreadcrumbItem = (
  props: FintechMarketplaceProductBreadcrumbItemProps
) => {
  const { children, active } = props;

  const [block, cn] = useModuleBEM(
    useFintechUiStyles(
      CoreFintechUiComponents.FintechMarketplaceProductBreadcrumbItem,
      defaultStyles
    ),
    CoreFintechUiComponents.FintechMarketplaceProductBreadcrumbItem
  );

  return (
    <div className={block}>
      <div
        className={cn("content", [], {
          active: active,
        })}
      >
        {children}
      </div>
    </div>
  );
};
